<template>
  <div id="Cases">
    <div class="Cases_main">
      <div class="Cases_title">
        <h3>{{ organDetail.organName }}</h3>
      </div>
      <div class="Cases_index">
        <p>
          {{ organDetail.briefIntroduce }}
        </p>
        <div class="Cases_img">
          <img :src="organDetail.coverPictureUrl" alt="" />
        </div>
        <div class="content" v-html="organDetail.datas"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { getOrgansList } from "../axiosAPI";

export default {
  name: "Cases",
  data() {
    return {
      organDetail: {},
    };
  },
  mounted() {
    this.getOrgan();
  },
  methods: {
    // 机构列表查询
    getOrgan() {
      var url = window.location.href;
      var organName = decodeURIComponent(
        url.substring(url.indexOf("=") + 1).toUpperCase()
      );
      console.log(organName, "organName");
      let query = this.$qs.stringify({
        organName: organName,
        type: "2",
      });
      getOrgansList(query).then((res) => {
        if (res.data.code == 200) {
          this.organDetail = res.data.item[0];
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
#Cases {
  width: 100%;
  height: 100vh;
  background: url(../assets/img/casebg.jpg) no-repeat center;
  background-size: cover;
  // background: #fceabb; /* fallback for old browsers */
  // background: -webkit-linear-gradient(
  //   to right,
  //   #f7c02ba1,
  //   #fceabb
  // ); /* Chrome 10-25, Safari 5.1-6 */
  // background: linear-gradient(
  //   to right,
  //   #f7c02ba1,
  //   #fceabb
  // ); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */

  .Cases_main {
    width: 75%;
    margin: 0 auto;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    align-items: center;
    .Cases_title {
      width: 80%;
      height: 1rem;
      line-height: 1rem;
      text-align: center;
      border-bottom: 1px solid #f0f0f0;
      font-size: 0.28rem;
    }
    .Cases_index {
      width: 80%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      p {
        line-height: 0.3rem;
        font-size: 0.2rem;
        padding: 0.2rem 0;

        &:nth-child(3) {
          text-indent: 2em;
        }
      }
      .Cases_img {
        text-align: center;
        img {
          width: 80%;
        }
      }
    }
  }
  @media screen and (max-width: 750px) {
    .Cases_main {
      width: 80%;
      .Cases_title {
        width: 100%;
      }
      .Cases_index {
        width: 100%;
        .content {
          padding: 0.5rem 0;
          text-indent: 2em;
          font-size: 0.25rem;
        }
      }
    }
  }
}
</style>
